/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./ResetPassword.css";
import PropTypes from "prop-types";

class ResetPassword extends Component {
  render() {
    const languageObj = this.props.languageObj;
    return (
      <div className="ResetPassword-view">
        <div className="ResetPassword-prompt">
          <div className="ResetPassword-mailboxIcn"></div>
          <div className="ResetPassword-text"> {languageObj.text}</div>
          <a href="/selectMission">
            <div className="ResetPassword-doneBtn">{languageObj.doneBtn}</div>
          </a>
        </div>
      </div>
    );
  }
}

ResetPassword.propTypes = {
  languageObj: PropTypes.object,
};

export default ResetPassword;
